import React from 'react';
import PropTypes from 'prop-types';

// I M P O R T A N T 

/* This component renders a text button. It has three props: 
    1) text  - text used for text button
    2  color - color of the text
    2) onClickHandler - function prop passed in by parent to handle click event.
    3) myclassname    - allows you to override existing default classes for special cases. 
*/
export const TextButton = (props) => {

    /* set defaults */
    let componentStyle = "text-button";

    /* intialize props */
    let { text, myclassname, color } = props;

    /* apply default overrides */
    if (myclassname) {
        componentStyle = props.myclassname;
    } else if (color) {
        componentStyle = "text-button-blue";
    }
    
    return (
        <div className="text-button-container">
            <div>
                <button className={`${componentStyle}`} onClick={props.onClickHandler} >
                    {text}
                </button>
            </div>
        </div>
    )
}

TextButton.propTypes = {
    text:                 PropTypes.string.isRequired,
    onClickHandler:       PropTypes.func.isRequired,
    color:                PropTypes.string,
    myclassname:          PropTypes.string
};





// WEBPACK FOOTER //
// ./src/components/buttons/TextButton.js